enum ActionTypes {
  REMOVE_BANNER_BAI = 'gofre/documents/REMOVE_BANNER_BAI',
}

export default ActionTypes;
